import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef } from "react";
import { useStringMap } from "../../utilities/string-map/useStringMap";
import { ArrowDownIcon } from "../../icons/ArrowDownIcon";
import { ArrowUpIcon } from "../../icons/ArrowUpIcon";
import { AppMenuList } from "../app-menu-list/AppMenuList";
import { AppMenuButton } from "./AppMenuButton";
import * as Styled from "./AppNavOverflowButton.styled";
import { stringMapDefault } from "./AppNavOverflowButton.stringMap";
const DefaultOverlay = (overflowListItems) => (_jsx(AppMenuList, { children: _jsx(AppMenuList, { children: overflowListItems }) }));
const componentName = "AppNavOverflowButton";
export const AppNavOverflowButton = forwardRef((props, ref) => {
    /* istanbul ignore next */
    const { overflowListItems = [], overlay = DefaultOverlay, shouldHideLabel = defaults.shouldHideLabel, stringMap: stringMapProp, ...otherProps } = props;
    const stringMap = useStringMap(componentName, { stringMapDefault, stringMapProp });
    // If overflow item is selected show it as the "More" text, other wise show first item
    const selectedValue = overflowListItems.find((element) => {
        // @ts-expect-error
        const { isActive } = element && element.props;
        return React.isValidElement(element) && isActive ? element : false;
    }) || overflowListItems[0];
    return (_jsxs(_Fragment, { children: [_jsx("ul", { role: "none", children: selectedValue }), _jsx(Styled.AppNavOverflowButtonWrapper, { children: _jsx(AppMenuButton, { "data-testid": "AppNavOverflowButton", ref: ref, hasTooltip: false, ...otherProps, label: _jsx(Styled.AppNavOverflowButtonLabel, { "aria-hidden": "true", children: "|" }), labelPlacement: "start", iconPadding: 4, icon: _jsx(ArrowDownIcon, { "aria-label": stringMap.overflowIconButton, size: 18 }), openIcon: _jsx(ArrowUpIcon, { "aria-label": stringMap.overflowIconButton, size: 18 }), shouldHideLabel: shouldHideLabel, 
                    // @ts-expect-error
                    overlay: overlay }) })] }));
});
AppNavOverflowButton.displayName = componentName;
const defaults = {
    shouldHideLabel: false
};
AppNavOverflowButton.defaultProps = defaults;
